export default {"src":"https://websiteoss.ecoflow.com/_next/static/media/bound_car.5d162353.webp","height":254,"width":350,"blurWidth":0,"blurHeight":0};